import { render } from "./App.vue?vue&type=template&id=bc4ad902&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=bc4ad902&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\ihcpayment\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc4ad902"]])

export default __exports__